import { render, staticRenderFns } from "./createQuality.vue?vue&type=template&id=58ca12d4&scoped=true&"
import script from "./createQuality.vue?vue&type=script&lang=ts&"
export * from "./createQuality.vue?vue&type=script&lang=ts&"
import style0 from "./createQuality.vue?vue&type=style&index=0&id=58ca12d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca12d4",
  null
  
)

export default component.exports